import posthog from 'posthog-js';
import { getConsentState, onConsentChange } from './consentService';
import { PostHogAction, PostHogStatus, mayCapture, planPostHogTransition, statusAfter, } from './posthogConsent';
// PostHog runs only with Statistics consent. Until then posthog.init has not
// run, so the shared posthog object (the one PostHogProvider hands to
// usePostHog) drops every capture: nothing is queued and nothing is stored.
let status = PostHogStatus.Uninitialized;
// The signed-in user, held in page memory so an identify that happens before
// consent arrives (session restore usually beats CookieYes loading) is applied
// the moment PostHog starts.
let signedInIdentity = null;
const initialize = () => {
    posthog.init(REACT_APP_POSTHOG_KEY, {
        api_host: REACT_APP_POSTHOG_ENDPOINT || 'https://us.i.posthog.com',
        defaults: '2025-05-24',
        capture_pageview: 'history_change',
        capture_pageleave: 'if_capture_pageview',
        autocapture: true,
        person_profiles: 'identified_only',
        opt_out_persistence_by_default: true,
        before_send: (event) => (mayCapture(status) ? event : null),
    });
    if (posthog.has_opted_out_capturing()) {
        posthog.opt_in_capturing({ captureEventName: false });
    }
    if (signedInIdentity) {
        posthog.identify(signedInIdentity.userId, signedInIdentity.properties);
    }
};
const suspend = () => {
    posthog.opt_out_capturing();
    posthog.set_config({ disable_persistence: true });
};
const resume = () => {
    posthog.set_config({ disable_persistence: false });
    posthog.opt_in_capturing({ captureEventName: false });
    if (signedInIdentity) {
        posthog.identify(signedInIdentity.userId, signedInIdentity.properties);
    }
};
const applyConsent = (statisticsGranted) => {
    const action = planPostHogTransition(status, statisticsGranted);
    status = statusAfter(status, action);
    switch (action) {
        case PostHogAction.Init:
            initialize();
            return;
        case PostHogAction.Resume:
            resume();
            return;
        case PostHogAction.Suspend:
            suspend();
            return;
        default:
            return;
    }
};
export const startPostHogWithConsent = () => {
    if (!REACT_APP_POSTHOG_KEY) {
        console.warn('PostHog API key not configured');
        return;
    }
    applyConsent(getConsentState().statistics);
    onConsentChange((state) => applyConsent(state.statistics));
};
export const identifyAnalyticsUser = (userId, properties) => {
    signedInIdentity = { userId, properties };
    if (mayCapture(status)) {
        posthog.identify(userId, properties);
    }
};
export const resetAnalyticsUser = () => {
    signedInIdentity = null;
    if (status !== PostHogStatus.Uninitialized) {
        posthog.reset();
    }
};
// The distinct id for the x-posthog-distinct-id header, which lets the server
// attach its own events to this visitor. Empty without Statistics consent.
export const getAnalyticsDistinctId = () => mayCapture(status) ? posthog.get_distinct_id() || '' : '';
export { posthog };
